<template>
    <el-dialog
        class="edit-ioss"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit IOSS"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="60px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                v-model="editForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="IOSS" prop="ioss" size="small">
                            <el-input
                                v-model="editForm.ioss"
                                placeholder="Please input ioss"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Status" prop="status" size="small">
                            <!-- <el-select
                                v-model="editForm.status"
                                placeholder="Please select status"
                                filterable
                                clearable
                                :remote="true"
                            >
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select> -->
                            <el-radio-group v-model="editForm.status">
                                <el-radio v-for="item in statusList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                ioss: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                ioss: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
            },
            statusList: [
                {
                    id: 1,
                    name: "Normal",
                },
                /* {
                    id: 2,
                    name: "Used",
                }, */
                {
                    id: 3,
                    name: "Invalid",
                },
            ],
        };
    },
    methods: {
        closeDialog() {
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .iossList(
                            {
                                name: this.editForm.name,
                                ioss: this.editForm.ioss,
                                status: this.editForm.status,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        iossList() {
            cmofferApi
                .iossList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        console.log("res: ", res);
                        this.editForm = { ...res.data };
                    }
                })
                .catch(() => {});
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible(val) {
            if (val) {
                this.iossList();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit-ioss {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
